// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { ProcurementUserProvider } from './context/ProcurementUserContext';
import { AuthProvider } from './components/auth/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import MainLayout from './components/layout/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Account from './pages/Account';
import EdgeAgents from './pages/EdgeAgents';
import Assets from './pages/Assets';
import Events from './pages/Events';
import Policies from './pages/Policies';
import EdgeNodes from './pages/EdgeNodes';
import Chat from './pages/Chat';
import NetworkTopology from './pages/NetworkTopology';
import AISentryV2 from './pages/AISentryV2';
import AISentry from './pages/AISentry';
import AISentryMobile from './pages/AISentryMobile';
import FleetSentry from './pages/FleetSentry';
import DataCenterSentry from './pages/DataCenterSentry';
import DCSentry from './pages/DCSentry';
import DCFleet from './pages/DCFleet';
import PublicSafetySentry from './pages/PublicSafetySentry';
import PrinterOpsSentry from './pages/PrinterOpsSentry';
import PipelineSentry from './pages/PipelineSentry';
import BuildingSentry from './pages/BuildingSentry';
import ConstructionSentry from './pages/ConstructionSentry';
import MaritimeSentry from './pages/MaritimeSentry';
import ModularDCSentry from './pages/ModularDCSentry';
import HPExecutiveDashboard from './pages/HPExecutiveDashboard';
import HPRevenueControlSentry from './pages/HPRevenueControlSentry';
import SovereignEdgeTopology, { SovereignEdgePrint, SovereignEdgeMedical, SovereignEdgeDC } from './pages/SovereignEdgeTopology';
import SovereignEdgeTopologyLight from './pages/SovereignEdgeTopologyLight';
import NetworkTopologyLight from './pages/NetworkTopologyLight';
import AISentryLight from './pages/AISentryLight';
import SignalsDashboard from './pages/SignalsDashboard';
import SignalsRawData from './pages/SignalsRawData';
import AxiomPortfolio from './pages/AxiomPortfolio';
import AxiomPortfolioV2 from './pages/AxiomPortfolioV2';
import AxiomPortfolioV3 from './pages/AxiomPortfolioV3';
import AxiomPolicies from './pages/AxiomPolicies';
import AxiomPoliciesV3 from './pages/AxiomPoliciesV3';
import AxiomPortfolioBriefing from './pages/AxiomPortfolioBriefing';
import AxiomNarrativeMicrosite from './pages/AxiomNarrativeMicrosite';
import PlatformStory from './pages/PlatformStory';
import AxiomInteractiveProductTour from './pages/AxiomInteractiveProductTour';
import PrinterStory from './pages/PrinterStory';
import MedicalStory from './pages/MedicalStory';
import MedicalStoryInvestors from './pages/MedicalStoryInvestors';
import Axiomui from './pages/Axiomui';
import AxiomStakeholder from './pages/AxiomStakeholder';
import ProjectOracle from './pages/ProjectOracle';
import ProjectOracleV2 from './pages/ProjectOracleV2';
import IntelligenceDataSources from './pages/IntelligenceDataSources';
import IntelligenceAudit from './pages/IntelligenceAudit';
import IntelligenceMarkets from './pages/IntelligenceMarkets';
import Briefings from './pages/Briefings';
import FourRivers from './pages/FourRivers';
import ProcurementStory from './pages/ProcurementStory';
import ProcurementStoryV2 from './pages/ProcurementStory_v2';
import ProcurementStoryMobile from './pages/ProcurementStoryMobile';
import ProcurementStoryV2Mobile from './pages/ProcurementStory_v2_Mobile';
import PlatformStoryMobile from './pages/PlatformStoryMobile';
import ProcurementDashboard from './pages/ProcurementDashboard';
import ProductionPlanner from './pages/ProductionPlanner';
import ProjectFinancials from './pages/ProjectFinancials';
import DesignManagement from './pages/DesignManagement';
import ProjectSchedule from './pages/ProjectSchedule';
import ProjectDocumentation from './pages/ProjectDocumentation';
import CxLookAhead from './pages/CxLookAhead';
import SystemHealth from './pages/SystemHealth';
import EasterStory from './pages/easterstory';
import AlignedSalesWall from './pages/AlignedSalesWall';
import AlignedSalesWallMobile from './pages/AlignedSalesWallMobile';
import CodingTerminal from './pages/CodingTerminal';
import BusinessPlanner from './pages/BusinessPlanner';








function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public route */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes - auth check only */}
          <Route element={<ProtectedRoute />}>
            
            {/* Mobile routes - NO MainLayout (full screen mobile UI) */}
            <Route path="/mobile" element={<AISentryMobile />} />
            <Route path="/m" element={<AISentryMobile />} />
            <Route path="/m/procurement-story" element={<ProcurementStoryMobile />} />
            <Route path="/m/procurement-story-v2" element={<ProcurementStoryV2Mobile />} />
            <Route path="/m/platform-story" element={<PlatformStoryMobile />} />
            <Route path="/m/aligned" element={<AlignedSalesWallMobile />} />
            
            {/* Full-screen terminals — no sidebar, own home button */}
            <Route path="/forge" element={<CodingTerminal />} />
            <Route path="/stratos" element={<BusinessPlanner />} />

            {/* Desktop routes - WITH MainLayout (sidebar, header, etc) */}
            <Route element={<MainLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/account" element={<Account />} />
              <Route path="/edge-agents" element={<EdgeAgents />} />
              <Route path="/assets/*" element={<Assets />} />
              <Route path="/events/*" element={<Events />} />
              <Route path="/policies/*" element={<Policies />} />
              <Route path="/edge-nodes/*" element={<EdgeNodes />} />
              <Route path="/topology" element={<NetworkTopology />} />
              <Route path="/ai-sentry" element={<AISentry />} />
              <Route path="/fleet-sentry" element={<FleetSentry />} />
              <Route path="/datacenter-sentry" element={<DataCenterSentry />} />
              <Route path="/safety-sentry" element={<PublicSafetySentry />} />
              <Route path="/printer-sentry" element={<PrinterOpsSentry />} />
              <Route path="/building-sentry" element={<BuildingSentry />} />
              <Route path="/construction-sentry" element={<ConstructionSentry />} />
              <Route path="/hp-executive" element={<HPExecutiveDashboard />} />
	      <Route path="/hp-revenue-control" element={<HPRevenueControlSentry />} />
              <Route path="/maritime-sentry" element={<MaritimeSentry />} />
              <Route path="/dc-sentry" element={<DCSentry />} />
              <Route path="/dc-fleet" element={<DCFleet />} />
              <Route path="/modular-dc-sentry" element={<ModularDCSentry />} />
              <Route path="/sovereign-edge" element={<SovereignEdgePrint />} />
              <Route path="/sovereign-edge-medical" element={<SovereignEdgeMedical />} />
              <Route path="/sovereign-edge-dc" element={<SovereignEdgeDC />} />
              <Route path="/sovereign-edge-light" element={<SovereignEdgeTopologyLight />} />
	      <Route path="/topology-light" element={<NetworkTopologyLight />} />
	      <Route path="/ai-sentry-light" element={<AISentryLight />} />
	      


              <Route path="/axiom-portfolio" element={<AxiomPortfolio />} />
              <Route path="/axiom-portfolio-v2" element={<AxiomPortfolioV2 />} />
              <Route path="/axiom-portfolio-v3" element={<AxiomPortfolioV3 />} />
              <Route path="/axiom-policies" element={<AxiomPolicies />} />
              <Route path="/axiom-policies-v3" element={<AxiomPoliciesV3 />} />
              <Route path="/axiom-briefing" element={<AxiomPortfolioBriefing />} />
              <Route path="/axiom-story" element={<AxiomNarrativeMicrosite />} />
              <Route path="/axiom-tour" element={<AxiomInteractiveProductTour />} />
              <Route path="/platform-story" element={<PlatformStory />} />
              <Route path="/printer-story" element={<PrinterStory />} />
              <Route path="/medical-story" element={<MedicalStory />} />
              <Route path="/medical-story-investors" element={<MedicalStoryInvestors />} />
              <Route path="/axiom-intelligence" element={<Axiomui />} />
              <Route path="/axiom-stakeholder" element={<AxiomStakeholder />} />
              <Route path="/project-oracle" element={<ProjectOracle />} />
              <Route path="/project-oracle-v2" element={<ProjectOracleV2 />} />
              <Route path="/pipeline-sentry" element={<PipelineSentry />} />
              <Route path="/ai-sentry-v2" element={<AISentryV2 />} />
              <Route path="/signals" element={<SignalsDashboard />} />
              <Route path="/signals/raw" element={<SignalsRawData />} />
              <Route path="/intelligence/sources" element={<IntelligenceDataSources />} />
              <Route path="/intelligence/audit" element={<IntelligenceAudit />} />
              <Route path="/intelligence/markets" element={<IntelligenceMarkets />} />
              <Route path="/briefings" element={<Briefings />} />
              <Route path="/four-rivers" element={<FourRivers />} />
              <Route path="/procurement-story" element={<ProcurementStory />} />
              <Route path="/procurement-story-v2" element={<ProcurementStoryV2 />} />
              <Route path="/procurement" element={<ProcurementUserProvider><Outlet /></ProcurementUserProvider>}>
                <Route index element={<ProcurementDashboard />} />
                <Route path="planner" element={<ProductionPlanner />} />
                <Route path="financials" element={<ProjectFinancials />} />
                <Route path="design" element={<DesignManagement />} />
                <Route path="schedule" element={<ProjectSchedule />} />
                <Route path="documentation" element={<ProjectDocumentation />} />
                <Route path="cx-lookahead" element={<CxLookAhead />} />
              </Route>
              <Route path="/health" element={<SystemHealth />} />
              <Route path="/easter-story" element={<EasterStory />} />
              <Route path="/aligned" element={<AlignedSalesWall />} />
              <Route path="/chat" element={<Chat />} />
            </Route>
          </Route>
          
          {/* Redirect root to Network Topology */}
          <Route path="/" element={<Navigate to="/health" replace />} />
          
          {/* 404 page */}
          <Route path="*" element={
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
              <div className="text-center">
                <h1 className="text-4xl font-bold text-gray-900">404</h1>
                <p className="mt-2 text-lg text-gray-600">Page not found</p>
                <p className="mt-4">
                  <a href="/topology" className="text-blue-600 hover:text-blue-500">
                    Go back to Network Topology
                  </a>
                </p>
              </div>
            </div>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
